export const DEFAULT_REPORTS_REQ_PARAMS = {
  page: 1,
  limit: 20
};
